const { COOKIES_POLICY_PAGE_ROUTE } = Config;

import React from "react";
import { useTranslation } from "react-i18next";
import Link, { LinkStyles } from "./Link.jsx";

export function CookiesPopupStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .cookies-popup-wrap": {
            display: "grid",
            gridAutoFlow: "column",
            gridGap: "20px",
            gridTemplateColumns: "4fr 1fr",
            alignItems: "center",

            zIndex: "2200",
            position: "fixed",
            left: "24px",
            bottom: "24px",
            right: "24px",
            padding: "20px",

            backgroundColor: "#ffffff",
            border: "2px solid #000000",
            borderRadius: "4px",
            boxShadow: "0 0 4px rgb(0 0 0 / 25%)",

            transition: "all 250ms ease",

            display: "none",
            "&.show": {
                display: "grid",
            },

            "& .cookies-popup-content": {
                display: "grid",
                gridGap: "16px",
                padding: "10px 0 10px 40px",
            },

            "&.accepted": {
                transform: "translateY(20px)",
                opacity: 0,
                pointerEvents: "none",
            },

            "& .popup-cookies-btn": {
                width: "100%",
                minHeight: "48px",
                padding: "15px 32px",
                fontSize: "16px",
                border: "none",
                backgroundColor: "#000000",
                color: "#ffffff",
                borderRadius: "4px",
                filter: "brightness(1) invert(0)",
                transition: "all 250ms ease",
                cursor: "pointer",
            },

            "& .popup-cookies-btn:hover": {
                filter: "brightness(1) invert(1)",
                border: "1px dotted",
            },
        },

        [MobileBreakpoint]: {
            "& .cookies-popup-wrap": {
                gridAutoFlow: "row",
                gridGap: 0,
                margin: 0,
                gridTemplateColumns: "auto",
                bottom: 0,
                left: 0,
                top: "unset",
                width: "100vw",
            },
        },

        ...LinkStyles(params),
    };
}

export default function CookiesPopup(props) {
    const { t } = useTranslation();
    const { Legacy, Texts } = props.variables;
    const LegacyCookies = Legacy?.filter(({ type }) => type === "cookies-policy")?.[0];

    return (
        <div className="cookies-popup-wrap ignore-global">
            <div className="cookies-popup-content">
                <h2>{Texts?.CookiesTitle || t("CookiesTitle")}</h2>

                <p>
                    <span>{Texts?.CookiesMessage1 || t("CookiesMessage1")}</span>

                    <span>
                        <Link href={LegacyCookies?.link || COOKIES_POLICY_PAGE_ROUTE} target="_blank">
                            {Texts?.CookiesMessageLink || t("CookiesMessageLink")}
                        </Link>
                    </span>

                    <span> {Texts?.CookiesMessage2 || t("CookiesMessage2")}</span>
                </p>
            </div>

            <button className="popup-cookies-btn">{Texts?.AcceptCookies || t("AcceptCookies")}</button>
        </div>
    );
}
